module.exports = __webpack_public_path__ + "img/57.eeb6d6bd.jpg";